import { API_URL } from "env"; // Đảm bảo đường dẫn import đúng

// ==========================================
// 1. DEFINITIONS (Type & Interface)
// ==========================================

// Interface cho Flash Sale
export interface PromotionFlashSale {
    product_id: number;
    percent: number;
    promotion_flash_sale?: {
        name: string;
        start_time: string;
        end_time: string;
    } | null;
}

// Interface chi tiết sản phẩm
export interface ProductDetailData {
    id: number;
    name: string;
    price: number;
    slug: string;
    list_thumbnail: string; // Chuỗi JSON stringified
    product_category: {
        id: number;
        name: string;
        slug?: string;
    };
    promotion_flash_sale_product: PromotionFlashSale[];
    content?: string;
    ingredients?: string;
    indications?: string;
    contraindications?: string;
    dosage?: string;
    drug_interactions?: string;
    storage?: string;
    overdose?: string;
    seo_page?: string;
    customer_like?: CustomerLike[];
}

// Interface Response chuẩn từ API cho chi tiết sản phẩm
export interface ProductDetailResponse {
    status: boolean;
    data: ProductDetailData;
    msg: string;
}

export interface CustomerLike {
    id: number;
    product_id: number;
    customer_id: number;
    is_like: number;
}

async function fetchProductDetail(slug: string, userId?: number | string): Promise<ProductDetailResponse | null> {
    // 1. Validate slug
    if (!slug) {
        console.error("fetchProductDetail: Slug is required");
        return null;
    }

    const query = new URLSearchParams();
    if (userId) {
        query.append('customer_id_like', String(userId));
    }

    // 2. Construct URL: {{link}}/api/v1/fe/product/:slug
    const baseUrl = `${API_URL.replace(/\/$/, '')}/api/v1/fe/product/${slug}`;
    const url = `${baseUrl}?${query.toString()}`;

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                // 'Authorization': `Bearer ${token}` 
            },
        });

        if (!response.ok) {
            // Nếu 404 thì return null để UI biết hiển thị trang Not Found
            if (response.status === 404) return null;
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data: ProductDetailResponse = await response.json();
        return data;

    } catch (error) {
        console.error(`Failed to fetch product detail [${slug}]:`, error);
        return null;
    }
}

export async function fetchRelatedProducts(categoryId: number) {
    // 1. Validate
    if (!categoryId) {
        console.error("fetchRelatedProducts: categoryId is required");
        return null;
    }

    // 2. Construct URLSearchParams
    const query = new URLSearchParams();
    query.append('sort[]', 'created_at,desc');
    query.append('product_category_id', String(categoryId));
    query.append('limit', '6');

    // 3. Construct URL
    const url = `${API_URL.replace(/\/$/, '')}/api/v1/fe/products?${query.toString()}`;

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                // 'Authorization': `Bearer ${token}`
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;

    } catch (error) {
        console.error(`Failed to fetch related products for category [${categoryId}]:`, error);
        return null;
    }
}

export async function sendPriceAssessment(productId: number, isLike: number) {
    const url = `${API_URL.replace(/\/$/, '')}/api/v1/fe/customer_like`;
    const token = localStorage.getItem('token');

    if (!token) return { status: false, msg: "Vui lòng đăng nhập để đánh giá" };

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                product_id: productId,
                is_like: isLike
            })
        });

        return await response.json();
    } catch (error) {
        console.error("Lỗi đánh giá:", error);
        return { status: false, msg: "Lỗi kết nối" };
    }
}

// ==========================================
// 3. EXPORTS
// ==========================================

export {
    fetchProductDetail,
};